export default __webpack_public_path__ + "static/media/nl.78cda36a.jpg";